<template>
    <div v-if="summary.length" class="flex flex-wrap gap-1">
        <custom-tooltip v-for="group in summary" :key="group.resource" border>
            <span
                class="inline-flex items-center gap-1 rounded-full border border-theme-border px-2 py-0.5 text-xs text-theme-base whitespace-nowrap"
            >
                {{ group.label }}
                <span class="font-semibold"
                    >· {{ group.permissions.length }}</span
                >
            </span>
            <template #tooltip>
                <p class="font-medium text-theme-base mb-1">
                    {{ group.label }}
                </p>
                <ul class="space-y-0.5">
                    <li
                        v-for="permission in group.permissions"
                        :key="permission.slug"
                        class="text-theme-muted"
                    >
                        {{ permission.name }}
                        <span class="font-mono text-xs">
                            ({{ permission.slug }})
                        </span>
                    </li>
                </ul>
            </template>
        </custom-tooltip>
    </div>
    <span v-else class="text-sm text-theme-muted">Sin permisos</span>
</template>

<script>
import { groupApiKeyPermissions } from "@/common/fields/api-key-permissions";

import CustomTooltip from "@/components/utils/CustomTooltip.vue";

export default {
    name: "ApiKeyPermissionsSummary",
    components: { CustomTooltip },
    props: {
        // Slugs de la key (`permissions` de `GET /bo/api-keys`).
        permissions: {
            type: Array,
            default: () => []
        },
        // Catálogo de `GET /bo/api-keys/permissions`; vacío si no cargó.
        groups: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        summary() {
            return groupApiKeyPermissions(this.permissions, this.groups);
        }
    }
};
</script>
